import React, { useState, useEffect } from 'react';
import { Form, Button, Modal, Switch } from 'antd';
import { useDispatch } from 'react-redux';
import { CloseIcon } from '../../../../assets/icons';
import './Modals.scss';
import { updateUserProfile } from '../../../../services/authApi/userApi';
import { toastNotify } from '../../../../utils/toastNotify';
import { changeAccreditedDetails } from '../../../../store/reducer/accountSlice';
import RegDModal from '../../../../components/RegDModal';

const EditAccreditDetails = (props) => {
  const { setSuccessOpen, setModalOpen, isSelfAttestment, setIsSelfAttestment, isEditAccredit, setIsEditAccredit } = props;
  const [loading, setLoaing] = useState(false);
  const [questionsChecked, setQuestionsChecked] = useState({});
  const [disableContinue, setDisableContinue] = useState(true);
  const [disableContinueForQue5, setDisableContinueForQue5] = useState(true);
  const [isRegDModal, setIsRegDModal] = useState(false);
  const [uploadedDoc, setUploadedDoc] = useState([])
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { userProfileData } = props;

  useEffect(() => {
    handleResetValue();
    if (userProfileData?.investorStatus?.question5 === false) {
      form.setFieldsValue({
        question5: false,
      })
    } else {
      form.setFieldsValue({
        question5: true,
      })
    }
  }, []);

  const handlerSwitch = (value) => {
    setIsSelfAttestment(false);
    setDisableContinueForQue5(false)
    if (!isEditAccredit) {
      if (!value) { // Check if the switch value is false
        form.setFieldsValue({
          question5: false,
        });
        setUploadedDoc([]);
      } else {
        setIsRegDModal(true); // Open modal only if switch is ON
      }
    }
    handleCheckChanges({ ...questionsChecked, question5: value });
  };


  const onEditAccreditSubmit = async (values) => {
    if (Object.values(values).includes(true) || isSelfAttestment) {
      setLoaing(true);
      const accreditFormData = {
        investorStatus: { ...values },
        selfAttestment: isSelfAttestment,
      };
      if (values.question5) {
        accreditFormData.investorStatus.docs = uploadedDoc;
      }
      try {
        const resp = await updateUserProfile(accreditFormData);
        const firstFourQuestions = Object.values(accreditFormData.investorStatus).slice(0, 4);
        const isAccredited = firstFourQuestions.includes(true) || resp?.data?.user?.isRegDInvestor === "Approved";
        const role = isAccredited ? 'Accredited' : 'Investor';
        if (!resp.isError) {
          dispatch(
            changeAccreditedDetails({
              role,
              investorStatus: accreditFormData.investorStatus,
              isRegDInvestor: resp?.data?.user?.isRegDInvestor,
            })
          );
          props.setClose(false);
          setIsSelfAttestment(false)
          setSuccessOpen(true);
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoaing(false);
      }
    } else {
      props.setClose(false);
      setModalOpen(true);
    }
  };

  const handleCheckChanges = (value) => {
    const { question5: excludedProp, ...questions } = userProfileData.investorStatus
    const { question5, ...questionsValue } = value
    const areOtherQuestionsChecked = Object.keys(questionsValue).some((key) => value[key] !== questions[key]);
    setDisableContinue(!(areOtherQuestionsChecked));
    setQuestionsChecked(value);
  }

  const handleResetValue = () => {
    if (Object.keys(userProfileData).length > 0 && Object.keys(userProfileData.investorStatus).length > 0) {
      form.setFieldsValue({
        ...userProfileData.investorStatus,
      });
      setIsSelfAttestment(userProfileData?.selfAttestment)
      setQuestionsChecked({ ...userProfileData.investorStatus })
    }
  }

  const handleOnCloseClick = () => {
    if (Object.keys(userProfileData).length > 0 && Object.keys(userProfileData.investorStatus).length > 0) {
      form.setFieldsValue({
        ...userProfileData.investorStatus,
      });
      setIsSelfAttestment(userProfileData?.selfAttestment)
      setQuestionsChecked({ ...userProfileData.investorStatus })
    }
  }

  return (
    <>
      <Modal
        className='account__modal editaccrmodal'
        open={props.setOpen}
        onCancel={() => {
          setDisableContinue(true)
          props.setClose(false);
          setModalOpen(false);
          setIsSelfAttestment(false);
          handleOnCloseClick();
          setIsEditAccredit(false);
        }}
        width={524}
        footer={false}
        closeIcon={<CloseIcon />}
        centered
      >
        <Form form={form} name='editAccreditForm' onFinish={onEditAccreditSubmit}>
          <>
            <h4 className='mb-4 account__modal__title'>Accredited investor check</h4>
            <p className='mb-40'>Select any of the statements that apply to you. You can still invest even if none apply to you.</p>
            <div className='accredited__list'>
              <div className='accredited__item'>
                <p className='accredited__item__name'>I individually earn $200k+ per year, or as a joint household, equivalent to $300k+ per year.</p>
                <Form.Item initialValue={false} name='question1' valuePropName='checked'>
                  <Switch
                    onChange={value => {
                      const newValue = { ...questionsChecked, question1: value };
                      handleCheckChanges(newValue);
                    }}
                    disabled={isEditAccredit}
                    onClick={() => setIsSelfAttestment(false)}
                    id='question1'
                  />
                </Form.Item>
              </div>
              <div className='accredited__item'>
                <p className='accredited__item__name'>My net worth is $1M+, excluding my primary residence.</p>
                <Form.Item initialValue={false} name='question2' valuePropName='checked'>
                  <Switch

                    onChange={value => {
                      const newValue = { ...questionsChecked, question2: value };
                      handleCheckChanges(newValue);
                    }}
                    disabled={isEditAccredit}
                    onClick={() => setIsSelfAttestment(false)}
                    id='question2'
                  />
                </Form.Item>
              </div>
              <div className='accredited__item'>
                <p className='accredited__item__name'>
                  Are you or a family member a senior executive or a 10% or greater share holder of a publicly traded company?
                </p>
                <Form.Item initialValue={false} name='question3' valuePropName='checked'>
                  <Switch
                    onChange={value => {
                      const newValue = { ...questionsChecked, question3: value };
                      handleCheckChanges(newValue);
                    }}
                    disabled={isEditAccredit}
                    onClick={() => setIsSelfAttestment(false)}
                    id='question3'
                  />
                </Form.Item>
              </div>
              <div className='accredited__item mb-40'>
                <p className='accredited__item__name'>
                  Are you or a family member a senior executive or a 5% or greater share holder of a company associated with a FINRA member,
                  organization, or the SEC?
                </p>
                <Form.Item initialValue={false} name='question4' valuePropName='checked'>
                  <Switch
                    onChange={value => {
                      const newValue = { ...questionsChecked, question4: value };
                      handleCheckChanges(newValue);
                    }}
                    disabled={isEditAccredit}
                    onClick={() => setIsSelfAttestment(false)}
                    id='question4'
                  />
                </Form.Item>
              </div>
              <div className='accredited__item mb-40'>
                <p className='accredited__item__name'>
                  Would you like to complete the Regulation D accredited investor process?
                </p>
                <Form.Item initialValue={false} name='question5' valuePropName='checked'>
                  <Switch
                    checked={questionsChecked.question5}
                    onChange={handlerSwitch}
                    disabled={`${userProfileData?.investorStatus?.question5 ? 'disabled-part' : ''}`}
                    id='question5'
                    title={`${userProfileData?.investorStatus?.question5 ? 'Your request for Regulation D process is already submitted and cannot be edited' : ''}`}
                  />
                </Form.Item>
              </div>
            </div>
            <Button disabled={disableContinue && disableContinueForQue5} type='primary' className='w-100' htmlType='submit' loading={loading}>
              Continue
            </Button>
          </>
        </Form>
      </Modal>
      {isRegDModal && (
        <RegDModal
          modalOpen={isRegDModal}
          closeModal={(value) => {
            setIsRegDModal(false)
            if (value === '1') {
              form.setFieldsValue({
                question5: false,
              });
              setUploadedDoc({});
            } else {
              form.setFieldsValue({ question5: true })
            }
          }}
          setUploadedDoc={setUploadedDoc}
        />
      )}
    </>
  );
};

export default EditAccreditDetails;